import React from "react";
import { Redirect } from "expo-router";
import * as Sentry from "@sentry/react-native";

// Don't send errors from development/local web builds
const isProduction = process.env["NODE_ENV"] === "production";

if (isProduction) {
  Sentry.init({
    dsn: "https://cdfa66f617df1dff2cca87e02832ce54@o4506895076229120.ingest.us.sentry.io/4506900449001472",
    environment: "web",

    // Adds more context data to events (IP address, cookies, user, etc.)
    // For more information, visit: https://docs.sentry.io/platforms/react-native/data-management/data-collected/
    sendDefaultPii: true,

    // Enable Logs
    enableLogs: true,

    // Configure Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    integrations: [Sentry.mobileReplayIntegration()],

    // uncomment the line below to enable Spotlight (https://spotlightjs.com)
    // spotlight: __DEV__,
  });
}

export default Sentry.wrap(function AppRoute() {
  return <Redirect href="/" />;
});
